
import { useEffect, useState } from 'react';
import { adminHttpClient } from '@/admin/lib/admin-http-client';
import { getAdminEndpointUrl } from '@/admin/lib/admin-api-config';

interface CardRow {
  id: string;
  cardType: string;
  lastFour: string;
  isDefault: boolean;
  installments: number;
  createdAt: string;
  allowsInstallments: boolean;
}

const formatDate = (iso: string) => {
  try {
    return new Intl.DateTimeFormat('es-CL', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'America/Santiago' }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export default function CompanyCardsPanel({ companyId }: { companyId: string }) {
  const [rows, setRows] = useState<CardRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await adminHttpClient.get<CardRow[]>(getAdminEndpointUrl('companyCards', 'list', { companyId }));
        setRows(data);
      } catch {
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [companyId]);

  return (
    <section className="rounded-xl border bg-card p-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="text-base font-semibold">Tarjetas inscritas (PAT)</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Tarjetas que el comercio inscribió vía Lups para cobro automático. Read-only — los datos vienen en vivo desde la API de Lups.
          </p>
        </div>
      </div>

      {loading && <p className="mt-4 text-sm text-muted-foreground">Cargando tarjetas…</p>}
      {!loading && rows.length === 0 && (
        <p className="mt-4 text-sm text-muted-foreground">Sin tarjetas inscritas. `lupsActivation` seguirá pendiente hasta que el comercio inscriba al menos una.</p>
      )}
      {!loading && rows.length > 0 && (
        <ul className="mt-4 divide-y divide-border">
          {rows.map((card) => (
            <li key={card.id} className="flex items-center justify-between gap-4 py-3">
              <div>
                <p className="text-sm font-medium">{card.cardType} ···· {card.lastFour}</p>
                <p className="text-xs text-muted-foreground">Inscrita {formatDate(card.createdAt)} · {card.installments} cuota{card.installments === 1 ? '' : 's'}</p>
              </div>
              {card.isDefault && (
                <span className="text-[11px] font-medium px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400">
                  Predeterminada
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
